import { render, staticRenderFns } from "./addGpExplainDialog.vue?vue&type=template&id=ddf4a32c&"
import script from "./addGpExplainDialog.vue?vue&type=script&lang=js&"
export * from "./addGpExplainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddf4a32c')) {
      api.createRecord('ddf4a32c', component.options)
    } else {
      api.reload('ddf4a32c', component.options)
    }
    module.hot.accept("./addGpExplainDialog.vue?vue&type=template&id=ddf4a32c&", function () {
      api.rerender('ddf4a32c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/addGpExplainDialog.vue"
export default component.exports